module.exports = __webpack_public_path__ + "static/media/diningGL.b4b16ce2.jpg";